module.exports = __webpack_public_path__ + "static/media/icon-circle.45b51295.svg";